module.exports = __webpack_public_path__ + "1959d9de338fea49559ebcdbc11d7185.svg";